<script lang="ts" setup>
import { useKeycloak } from '@nxtpeople/nxt-vue-keycloak';
import { setZoomLevel, useLoadingScreen, useWindowScaling } from '@nxtpeople/nxt-styles';
import { ModuleKey } from '@nxtpeople/nxt-vue-library';
import SetupPWA from './core/components/SetupPWA.vue';

// #region zoom
// Set default zoom for users that still have the custom zoom level set
setZoomLevel(1);
useWindowScaling(1.25, 0.9);
// #endregion

//#region Loading Screen
const { isPending } = useKeycloak();
const { showLoadingScreen, animationComplete } = useLoadingScreen(isPending);
//#endregion
</script>

<template>
   <div class="app">
      <router-view v-slot="{ Component }">
         <Transition name="fade" mode="out-in">
            <NxtLoadingScreen v-if="showLoadingScreen" :module-key="ModuleKey.NxtPlan" @animation-complete="animationComplete = true" />
            <component :is="Component" v-else />
         </Transition>
      </router-view>

      <!-- PWA -->
      <SetupPWA />
   </div>
</template>

<style src="@nxtpeople/nxt-styles/dist/style.css"></style>

<style lang="scss" scoped>
.app {
   height: 100vh;
}
</style>
